import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-content" }
const _hoisted_3 = { class: "mb-[20px] md:mb-[25px]" }
const _hoisted_4 = { class: "font-medium mb-[15px] md:mb-[19px] last:mb-0" }
const _hoisted_5 = { class: "bar-navs ltr:pl-[28px] rtl:pr-[28px] mt-[15px] md:mt-[17px] mb-[17px] md:mb-[21px]" }
const _hoisted_6 = { class: "font-normal mb-[12px] md:mb-[14px] last:mb-0" }
const _hoisted_7 = { class: "font-normal mb-[12px] md:mb-[14px] last:mb-0" }
const _hoisted_8 = { class: "font-normal mb-[12px] md:mb-[14px] last:mb-0" }
const _hoisted_9 = { class: "font-normal mb-[12px] md:mb-[14px] last:mb-0" }
const _hoisted_10 = { class: "font-medium mb-[15px] md:mb-[19px] last:mb-0" }
const _hoisted_11 = { class: "font-medium mb-[15px] md:mb-[19px] last:mb-0" }
const _hoisted_12 = { class: "font-medium mb-[15px] md:mb-[19px] last:mb-0" }
const _hoisted_13 = { class: "font-medium mb-[15px] md:mb-[19px] last:mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("form", { class: "relative mb-[20px] md:mb-[27px]" }, [
        _createElementVNode("input", {
          type: "text",
          class: "block w-full rounded-md text-black dark:text-white px-[15px] bg-gray-50 dark:bg-[#15203c] border border-gray-50 dark:border-[#15203c] focus:border-primary-500 h-[44px] outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400",
          placeholder: "Search here....."
        }),
        _createElementVNode("button", { class: "absolute text-primary-500 mt-px ltr:right-[15px] rtl:left-[15px] top-1/2 -translate-y-1/2 hover:text-primary-400" }, [
          _createElementVNode("i", { class: "material-symbols-outlined !text-[20px]" }, " search ")
        ])
      ], -1)),
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createVNode(_component_RouterLink, {
            to: "/apps/file-manager/my-drive",
            class: "relative flex items-center justify-between ltr:pl-[28px] rtl:pr-[28px] transition-all text-primary-500 hover:text-primary-500"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "material-symbols-outlined absolute !text-lg ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 -mt-[.5px]" }, " drive_eta ", -1),
              _createTextVNode(" My Drive "),
              _createElementVNode("span", { class: "text-sm font-normal block text-gray-500 dark:text-gray-400" }, " 4 ", -1)
            ])),
            _: 1
          }),
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createVNode(_component_RouterLink, {
                to: "/apps/file-manager/assets",
                class: "inline-block relative transition-all hover:text-primary-500 ltr:pl-[15px] rtl:pr-[15px]"
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createElementVNode("span", { class: "ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 w-[6px] h-[6px] rounded-full absolute border border-primary-500" }, null, -1),
                  _createTextVNode(" Assets ")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_7, [
              _createVNode(_component_RouterLink, {
                to: "/apps/file-manager/projects",
                class: "inline-block relative transition-all hover:text-primary-500 ltr:pl-[15px] rtl:pr-[15px]"
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createElementVNode("span", { class: "ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 w-[6px] h-[6px] rounded-full absolute border border-primary-500" }, null, -1),
                  _createTextVNode(" Projects ")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_8, [
              _createVNode(_component_RouterLink, {
                to: "/apps/file-manager/personal",
                class: "inline-block relative transition-all hover:text-primary-500 ltr:pl-[15px] rtl:pr-[15px]"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createElementVNode("span", { class: "ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 w-[6px] h-[6px] rounded-full absolute border border-primary-500" }, null, -1),
                  _createTextVNode(" Personal ")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_9, [
              _createVNode(_component_RouterLink, {
                to: "/apps/file-manager/applications",
                class: "inline-block relative transition-all hover:text-primary-500 ltr:pl-[15px] rtl:pr-[15px]"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createElementVNode("span", { class: "ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 w-[6px] h-[6px] rounded-full absolute border border-primary-500" }, null, -1),
                  _createTextVNode(" Applications ")
                ])),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_10, [
          _createVNode(_component_RouterLink, {
            to: "/apps/file-manager/documents",
            class: "relative flex items-center justify-between ltr:pl-[28px] rtl:pr-[28px] transition-all text-black dark:text-white hover:text-primary-500"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createElementVNode("i", { class: "material-symbols-outlined text-success-600 absolute !text-lg ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 -mt-[.5px]" }, " description ", -1),
              _createTextVNode(" Documents ")
            ])),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_11, [
          _createVNode(_component_RouterLink, {
            to: "/apps/file-manager/media",
            class: "relative flex items-center justify-between ltr:pl-[28px] rtl:pr-[28px] transition-all text-black dark:text-white hover:text-primary-500"
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createElementVNode("i", { class: "material-symbols-outlined text-info-400 absolute !text-lg ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 -mt-[.5px]" }, " perm_media ", -1),
              _createTextVNode(" Media ")
            ])),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_12, [
          _createVNode(_component_RouterLink, {
            to: "/apps/file-manager/recents",
            class: "relative flex items-center justify-between ltr:pl-[28px] rtl:pr-[28px] transition-all text-black dark:text-white hover:text-primary-500"
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createElementVNode("i", { class: "material-symbols-outlined text-purple-500 absolute !text-lg ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 -mt-[.5px]" }, " schedule ", -1),
              _createTextVNode(" Recents ")
            ])),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_13, [
          _createVNode(_component_RouterLink, {
            to: "/apps/file-manager/important",
            class: "relative flex items-center justify-between ltr:pl-[28px] rtl:pr-[28px] transition-all text-black dark:text-white hover:text-primary-500"
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createElementVNode("i", { class: "material-symbols-outlined text-warning-500 absolute !text-lg ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 -mt-[.5px]" }, " grade ", -1),
              _createTextVNode(" Important ")
            ])),
            _: 1
          })
        ]),
        _cache[9] || (_cache[9] = _createStaticVNode("<li class=\"font-medium mb-[15px] md:mb-[19px] last:mb-0\" data-v-1e7624dd><a href=\"#\" class=\"relative flex items-center justify-between ltr:pl-[28px] rtl:pr-[28px] transition-all text-black dark:text-white hover:text-primary-500\" data-v-1e7624dd><i class=\"material-symbols-outlined text-secondary-500 absolute !text-lg ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 -mt-[.5px]\" data-v-1e7624dd> report_gmailerrorred </i> Spam <span class=\"text-sm font-normal block text-gray-500 dark:text-gray-400\" data-v-1e7624dd> 10 </span></a></li><li class=\"font-medium mb-[15px] md:mb-[19px] last:mb-0\" data-v-1e7624dd><a href=\"#\" class=\"relative flex items-center justify-between ltr:pl-[28px] rtl:pr-[28px] transition-all text-black dark:text-white hover:text-primary-500\" data-v-1e7624dd><i class=\"material-symbols-outlined text-danger-500 absolute !text-lg ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 -mt-[.5px]\" data-v-1e7624dd> delete </i> Trash <span class=\"text-sm font-normal block text-gray-500 dark:text-gray-400\" data-v-1e7624dd> 15 </span></a></li>", 2))
      ]),
      _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"border-t border-gray-100 dark:border-[#172036] -mx-[20px] md:-mx-[25px] px-[20px] md:px-[25px] pt-[20px] md:pt-[25px]\" data-v-1e7624dd><h6 class=\"mb-[11px] text-[15px]\" data-v-1e7624dd>Storage Status</h6><span class=\"block text-sm\" data-v-1e7624dd> % 50 GB used of 100 GB </span><div class=\"mt-[11px] flex w-full h-[4px] overflow-hidden rounded-md bg-primary-50 dark:bg-[#172036]\" data-v-1e7624dd><div class=\"flex flex-col justify-center overflow-hidden bg-primary-500 rounded-md\" style=\"width:50%;\" data-v-1e7624dd></div></div></div>", 1))
    ])
  ]))
}